import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { GhostTag } from '../models/ghost';

const TagCloudWrapper = styled.div`
  margin: -0.5rem;

  button {
    display: inline-flex;
    margin: 0.5rem;
  }
`;

interface TagCloudProps {
  tags: GhostTag[];
  selected?: GhostTag[];
  onSelect: (tag: GhostTag) => void;
}

const TagCloud: React.FC<TagCloudProps> = ({ tags, selected = [], onSelect }) => {
  const mappedSelected: { [key: string]: GhostTag } = {};
  selected.forEach(tag => {
    mappedSelected[tag.slug] = tag;
  });

  return (
    <TagCloudWrapper>
      {tags.map((tag, index) => (
        <Button
          key={index}
          onClick={() => onSelect(tag)}
          type={mappedSelected[tag.slug] ? 'primary' : 'default'}
        >
          {tag.name}
        </Button>
      ))}
    </TagCloudWrapper>
  );
};

export default TagCloud;
